import Axios from 'core/axios';
import Rest from 'core/rest';
import Tools from 'core/tools';
// import Validation from 'core/validation';
// import { i18n } from 'core/i18n';
import {
	openMask, closeMask, openError
} from '../mainModule/action';

export const ACCOUNT_SEARCH_SUCCESS = 'ACCOUNT_SEARCH_SUCCESS';
export const ACCOUNT_SEARCH_SUCCESS_ERRORS = 'ACCOUNT_SEARCH_SUCCESS_ERRORS';
export const ACCOUNT_CLEAR_ACCOUNT_LIST = 'ACCOUNT_CLEAR_ACCOUNT_LIST';

export const search = (data) => {
	return (dispatch) => {
		dispatch(openMask());
		dispatch({
			type: ACCOUNT_CLEAR_ACCOUNT_LIST,
		});
		Axios.get(Rest.report.getAccountBalance(data))
			.then((response) => {
				dispatch({
					type: ACCOUNT_SEARCH_SUCCESS,
					data: response
				});
				dispatch(closeMask());
			})
			.catch((error) => {
				dispatch(closeMask());
				return dispatch(openError(error));
			});
	};
};

export const getAccountBalancePDF = (data) => {
	return (dispatch) => {
		dispatch(openMask());
		Axios.get(Rest.report.getAccountBalancePDF(data))
			.then((response) => {
				let agentName = sessionStorage.getItem('agentName');
				Tools.downloadFile(response.data, 'csv', `${data.start}_${data.end}_${agentName}_BalanceReport.csv`);
				dispatch(closeMask());
			})
			.catch((error) => {
				dispatch(closeMask());
				return dispatch(openError(error));
			});
	};
};

export const clearAccountList = () => {
	return (dispatch) => {
		dispatch({
			type: ACCOUNT_CLEAR_ACCOUNT_LIST,
		});
	};
};



